import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFiscalNotasFiscaisProduto } from '@/features/relatorio/page/fiscal/notas-fiscais-produto/RelatorioFiscalNotasFiscaisProduto';

export const Route = createFileRoute('/a/relatorio/fiscal/notas-fiscais-produto')({
    component: RelatorioFiscalNotasFiscaisProduto,
});
